import React from "react";
import AllMutualFundsFilters from "./AllMutualFundFilter/AllMutualFundsFilters";
import AllMutualFundWelcome from "./AllMutualFundWelcome/AllMutualFundWelcome";

function AllMutualFund() {
  return (
    <>
      <AllMutualFundWelcome />
      <AllMutualFundsFilters />
    </>
  );
}
export default AllMutualFund;
